import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';

import { Box } from '../../Box';
import { Typography } from '../../Typography';

interface TagProps {
  label: string;
  disabled: boolean;
  onDelete: () => void;
}

export const Tag = ({ label, disabled, onDelete }: TagProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="8"
      px="8"
      height={32}
      border={1}
      bgcolor="bg.greyscale.primary"
      borderColor="stroke.primary"
      radius="m"
    >
      <Typography variant="body3">{label}</Typography>
      {!disabled && (
        <Box width={20} height={20} cursor={disabled ? 'default' : 'pointer'}>
          <CloseIcon color="disabled" fontSize="small" onClick={onDelete} />
        </Box>
      )}
    </Box>
  );
};
